import * as actionTypes from './actionTypes'

import positionGroupAxios from '../../axios/positionGroup'

import { getListingIndex } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'

export const fetchPositionGroup = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions,
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 10
    }
    dispatch(fetchPositionGroupStart())

    positionGroupAxios
      .get('', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { current_page, from, last_page, per_page, to, total, data } = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: per_page,
            from,
            to,
            total
          }

          const dataWithOption = data.map((item, index) => {
            return { ...item, index: getListingIndex(index, per_page, current_page) }
          })

          dispatch(fetchPositionGroupSuccess(pagination, dataWithOption))
        }
      })
      .catch(error => {
        dispatch(fetchPositionGroupFailed(error))
      })
  }
}

export const fetchPositionGroupStart = () => {
  return {
    type: actionTypes.FETCH_POSITION_GROUP_START
  }
}

export const fetchPositionGroupSuccess = (pagination, records) => {
  return {
    type: actionTypes.FETCH_POSITION_GROUP_SUCCESS,
    pagination,
    records
  }
}

export const fetchPositionGroupFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_POSITION_GROUP_FAILED,
    errorMessage
  }
}

export const fetchPositionGroupById = recordId => {
  return dispatch => {
    dispatch(fetchPositionGroupStart())
    positionGroupAxios
      .get(`/${recordId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchPositionGroupByIdSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchPositionGroupFailed(error))
      })
  }
}

export const fetchPositionGroupByIdSuccess = recordData => {
  return {
    type: actionTypes.FETCH_POSITION_GROUP_BY_ID_SUCCESS,
    recordData
  }
}

export const clearSelectedPositionGroupRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_POSITION_GROUP_RECORD
  }
}

export const createPositionGroup = (recordData, page) => {
  return dispatch => {
    dispatch(createPositionGroupStart())

    positionGroupAxios
      .post('', recordData)
      .then(response => {
        if (response.status === 201) {
          dispatch(
            enqueueSnackbar({
              message: 'Position Group Created',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(createPositionGroupSuccess())
          dispatch(fetchPositionGroup(page))
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Position Group field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createPositionGroupFailed())
      })
  }
}

export const createPositionGroupStart = () => {
  return {
    type: actionTypes.CREATE_POSITION_GROUP_START
  }
}

export const createPositionGroupSuccess = () => {
  return {
    type: actionTypes.CREATE_POSITION_GROUP_SUCCESS
  }
}

export const createPositionGroupFailed = () => {
  return {
    type: actionTypes.CREATE_POSITION_GROUP_FAILED
  }
}

export const updatePositionGroup = (recordId, recordData, page) => {
  return dispatch => {
    dispatch(updatePositionGroupStart())

    positionGroupAxios
      .patch(`/${recordId}`, recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Position Group Updated',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(updatePositionGroupSuccess())
        dispatch(fetchPositionGroup(page))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Position Group field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(updatePositionGroupFailed())
      })
  }
}

export const updatePositionGroupStart = () => {
  return {
    type: actionTypes.UPDATE_POSITION_GROUP_START
  }
}

export const updatePositionGroupSuccess = () => {
  return {
    type: actionTypes.UPDATE_POSITION_GROUP_SUCCESS
  }
}

export const updatePositionGroupFailed = () => {
  return {
    type: actionTypes.UPDATE_POSITION_GROUP_FAILED
  }
}

export const deletePositionGroup = (recordId, page) => {
  return dispatch => {
    dispatch(deletePositionGroupStart())
    positionGroupAxios
      .delete(`/${recordId}`)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Position Group Deleted',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(deletePositionGroupSuccess())
        dispatch(fetchPositionGroup(page))
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: 'Deleted Failed',
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(deletePositionGroupFailed())
      })
  }
}

export const deletePositionGroupStart = () => {
  return {
    type: actionTypes.DELETE_POSITION_GROUP_START
  }
}

export const deletePositionGroupSuccess = () => {
  return {
    type: actionTypes.DELETE_POSITION_GROUP_SUCCESS
  }
}

export const deletePositionGroupFailed = () => {
  return {
    type: actionTypes.DELETE_POSITION_GROUP_FAILED
  }
}

export const fetchPositionGroupFilterActive = () => {
  return dispatch => {
    dispatch(fetchPositionGroupFilterActiveStart())
    let active = [
      {
        active_id: 1,
        active_code: 1,
        active_name: 'Active'
      },
      {
        active_id: 0,
        active_code: 0,
        active_name: 'Inactive'
      }
    ]

    if (active) {
      dispatch(fetchPositionGroupFilterActiveSuccess(active))
    } else {
      dispatch(fetchPositionGroupFilterActiveFailed('Get active fail'))
    }
  }
}

export const fetchPositionGroupFilterActiveStart = () => {
  return {
    type: actionTypes.FETCH_POSITION_GROUP_FILTER_ACTIVE_START
  }
}

export const fetchPositionGroupFilterActiveSuccess = data => {
  return {
    type: actionTypes.FETCH_POSITION_GROUP_FILTER_ACTIVE_SUCCESS,
    data
  }
}

export const fetchPositionGroupFilterActiveFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_POSITION_GROUP_FILTER_ACTIVE_FAILED,
    errorMessage
  }
}
